import React from "react";
import "../App.css";
import { FaCrown, FaHeadset, FaBalanceScale } from "react-icons/fa";

export default function Services() {
  return (
    <section id="services" className="services-section">
      <div className="container">
        <h2 className="section-title">Our Services</h2>

        <div className="services-grid">

          <div className="service-card clean">
            <FaCrown className="service-icon" />
            <h3>Premium Project Access</h3>
            <span className="underline"></span>
            <p>
              Luxury apartments, villas, high-rise residential & commercial projects from top developers in Bangalore.
            </p>
          </div>

          <div className="service-card clean">
            <FaHeadset className="service-icon" />
            <h3>End-to-End Support</h3>
            <span className="underline"></span>
            <p>
              Project shortlisting, guided site visits, negotiation support, documentation and loan coordination.
            </p>
          </div>

          <div className="service-card clean">
            <FaBalanceScale className="service-icon" />
            <h3>Transparent Guidance</h3>
            <span className="underline"></span>
            <p>
              Verified listings, expert advice, honest comparison & property evaluation — with zero brokerage.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}
